import { Component, OnInit, forwardRef } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  NavController,
  NavParams,
  ToastController,
  ModalController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BuscarPessoaPage } from "../../buscar-pessoa/buscar-pessoa.page";
import { ConfigProvider } from "src/app/services/config/config";
import { GrupoProvider } from "src/app/services/grupo/grupo";
import { format } from "date-fns";
import { CommonModule } from "@angular/common";
import { ImagePipe } from "src/app/pipes/image/image";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { MoneyPipe } from "src/app/pipes/money/money";

@Component({
  selector: "app-grupo-caixa-lancamento",
  templateUrl: "./grupo-caixa-lancamento.page.html",
  styleUrls: ["./grupo-caixa-lancamento.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    ReactiveFormsModule,
    DateFormatPipe,
    ProverDatepickerComponent,
    MoneyPipe,
  ],
})
export class GrupoCaixaLancamentoPage implements OnInit {
  tipo: any = "";
  pessoa: any = {};
  idGrupo: any = "";
  idGrupoCaixa: any = "";
  vincularPessoa: boolean = false;
  validations_form: FormGroup;
  itens: any = [];
  isSubmitting = false;
  validation_messages = {
    valor: [{ type: "required", message: this.translate.instant("Campo Obrigatório")}],
    data: [{ type: "required", message: this.translate.instant("Campo Obrigatório")}],
    item: [{ type: "required", message: this.translate.instant("Campo Obrigatório")}],
  };

  constructor(
    public navCtrl: NavController,
    public formBuilder: FormBuilder,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public configProvider: ConfigProvider,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public modalCtrl: ModalController
  ) {
    this.tipo = this.navParams.get("tipo");
    this.idGrupo = this.navParams.get("idGrupo");
    this.idGrupoCaixa = this.navParams.get("idGrupoCaixa");

    this.grupoProvider
      .getItensCaixa(this.tipo, this.idGrupo)
      .subscribe((data) => {
        this.itens = data;
      });

    this.validations_form = this.formBuilder.group({
      valor: new FormControl("", Validators.required),
      data: new FormControl(
        format(new Date(), "yyyy-MM-dd"),
        Validators.required
      ),
      item: new FormControl("", Validators.required),
      descricao: new FormControl("", Validators.nullValidator),
      idPessoa: new FormControl(""),
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async selecionarPessoa() {
    const dataPessoa = { isVisitante: false, adiciona: true };
    const modalPessoa = await this.modalCtrl.create({
      component: BuscarPessoaPage,
      componentProps: dataPessoa,
    });
    modalPessoa.present();

    const pessoa = await modalPessoa.onWillDismiss();
    if (pessoa.data) {
      this.pessoa = pessoa.data.pessoa;
    } else {
      this.vincularPessoa = false;
    }
  }

  changeVincular() {
    if (this.vincularPessoa) {
      this.selecionarPessoa();
    } else {
      this.pessoa = {};
    }
  }

  onSubmit(lancamento: any) {
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    if (this.vincularPessoa) {
      lancamento.idPessoa = this.pessoa.id;
    } else {
      lancamento.idPessoa = null;
    }

    lancamento.idGrupoCaixa = this.idGrupoCaixa;

    this.grupoProvider.salvarCaixaLancamento(this.tipo, lancamento).subscribe({
      next: async (data) => {
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("Lançamento criado com sucesso!"),
          duration: 3000,
        });
        toast.present();
        this.modalCtrl.dismiss(data);
      },
      error: async (err) => {
        this.isSubmitting = false;
        const toast = await this.toastCtrl.create({
          message: this.translate.instant("Erro ao realizar o Lançamento!"),
          duration: 3000,
          color: "danger",
        });
        toast.present();
      },
    });
  }

  async formatValor(event: any) {
    const rawValue = event.target.value.replace(/\D/g, "");
    const formatted = await new MoneyPipe(this.configProvider).transform(
      +rawValue
    );

    this.validations_form
      .get("valor")
      ?.setValue(formatted, { emitEvent: false });
  }
}
